import { environment } from '../../../environments/environment';

/**
 * True when `url` is `base` itself or a path/query/fragment below it. The boundary check keeps
 * look-alike hosts (https://gpt.xplorer-platform.dev.evil.com) from matching a bare host base.
 */
const isUnderBase = (url: string, base: string | undefined | null): boolean => {
  const normalizedBase = (base ?? '').replace(/\/+$/, '');
  // An empty base would match every URL, so it never matches.
  if (!url || !normalizedBase || !url.startsWith(normalizedBase)) {
    return false;
  }
  const next = url.charAt(normalizedBase.length);
  return next === '' || next === '/' || next === '?' || next === '#';
};

/**
 * Backends whose 401/403 responses say something about the user's session
 * (Xplorer backend, labels, Bussola).
 */
export function isFirstPartyApi(url: string): boolean {
  return [environment.BACKEND_API_URL, environment.BUSSOLA_URL]
    .some(base => isUnderBase(url, base));
}

/**
 * Hosts that receive the Bearer token. GPT, analytics and revalidation go through the backend proxy
 * (BACKEND_API_URL), so they are covered by the first-party bases.
 */
export function isBearerTarget(url: string): boolean {
  return isFirstPartyApi(url);
}
